import { render, staticRenderFns } from "./ChatOrderProfileAddressForm.vue?vue&type=template&id=9b4b9982&scoped=true&"
import script from "./ChatOrderProfileAddressForm.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileAddressForm.vue?vue&type=style&index=0&id=9b4b9982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4b9982",
  null
  
)

export default component.exports